import { number, object } from '@gogame/schemas';

import { LOOKALIKE_AUDIENCE, SHARE_ACCOUNTS } from './constants';

export const validationSchema = object({
  [LOOKALIKE_AUDIENCE]: number().required('Lookalike Audience  is required'),
  [SHARE_ACCOUNTS]: number().required('Shared Accounts  is required'),
});
